import { useMutation, useQueryClient } from '@tanstack/react-query';
import PaymentService from "../services";

interface StripeResponse {
    stripeCustomerId: string;
    // Add any other fields returned from the API
  }
  

export const useCreateStripeId = () => {
    const queryClient = useQueryClient();
  
    return useMutation<StripeResponse>({
      mutationFn: (values) => {
        return PaymentService.createStripeId(values);
      },
      onSuccess: () => {
        console.log('got stripe id successfully')
        // queryClient.invalidateQueries(['create-stripe-id']);
        queryClient.invalidateQueries({ queryKey: ['create-stripe-id'] });
      },
      onError: (error) => {
        console.error('Error using forgot password:', error);
      },
    });
  };
  

